


























import { Component, Vue } from 'vue-property-decorator';
import Container from '@tencent/wphk-components-third-app-redirect/index.vue';
import Jump2actBtn from '@tencent/wphk-components-third-app-redirect/components/jump2act-btn.vue';
import Header from './header.vue';
import { IPageInfo, ConfigType } from '../../types/config-type';
import { getPageInfoById, handleActUrl } from '../../business/page-info';
import { url, util, CustomException } from '@tencent/ppd-base-libs';
import { url as urlUtils } from '@tencent/wphk-base-utils';
import { mtnBiReport, getMtnBiReportParams } from '@tencent/wphk-components-mtn-bi-report';
import { redirectToUrl, redirectToWxApp } from '../../business/redirect';
import { createUrlInfo } from '../../business/url-schema';

@Component({
  components: {
    Container,
    Header,
    Jump2actBtn,
  },
})
export default class CIndex extends Vue {
  public pageInfo: IPageInfo = {
    confId: '',
    title: '',
    topImg: '',
    bgColor: '',
    btnTop: 782,
    btnText: '立即查看',
    btnColor: '#FFFFFF',
    actUrl: '',
  };
  public urlSchema = ''; // 拉起小程序的schema
  public isShowPage = false;

  private async created() {
    // confId是配置Id
    const confId = url.getUrlParam('confId');
    // 这里要同时根据adtag获取唯一配置 需兼容各类大小写：adtag、ADTAG、Adtag、adTag
    const adtag = urlUtils.getUrlAdtag() || '';
    // 配置类型: 物料 | 普通活动
    const confType = url.getUrlParam('confType') || ConfigType.general;
    // urlSchemaFromUrl：物料可直传urlschema，无需中转页生产，权重最高
    const urlSchemaFromUrl = url.getUrlParam('urlSchema') ? decodeURIComponent(url.getUrlParam('urlSchema')) : '';

    if (urlSchemaFromUrl) {
      // 处理安全漏洞，非微信urlSchema就拒绝跳转
      const isValidWeixinUrlSchema = /^weixin/.test(urlSchemaFromUrl);
      if (!isValidWeixinUrlSchema) {
        throw new CustomException('', 'InvalidUrlSchemaFromUrl', `invalid urlSchemaFromUrl: ${urlSchemaFromUrl}`);
      }
    }

    this.init(confId, adtag, confType, urlSchemaFromUrl);
  }

  private async init(
    confId: string,
    adtag: string,
    confType: ConfigType,
    urlSchemaFromUrl?: string,
  ) {
    const [err, configItem] = await util.to(getPageInfoById(confId, adtag, confType));
    const throwExt =  JSON.stringify({
      confId,
      adtag,
      confType,
    });
    if (err) {
      throw new CustomException(err, 'ThirdAppRedirectConfException', throwExt);
    }
    // 设置页面标题
    util.changeTitle(configItem.title);

    // 支持url上携带落地页，这时覆盖配置里的落地页
    const info = { ...configItem, ...this.configFromUrl };

    // 上报
    this.initReportData(confId, adtag, info.actUrl);

    // 页面信息，展示UI
    this.pageInfo = info;

    // 完成跳转
    const { wxAppId, wxAppPath, actUrl } = info;
    console.debug('pageInfo:', info);

    // 如果信息不全，告警
    if (!actUrl && !(wxAppPath && wxAppId) && !urlSchemaFromUrl) {
      throw new CustomException('', 'RedirectInfoEmptyException', JSON.stringify(info));
    }

    const {
      fvin: VIN,
      finorex: inorex,
      fbatchid: batchid,
      fcampaignid: campaignid,
      fmtn: MTN,
    } = getMtnBiReportParams();

    const { isInWx, isToH5, url: jumpUrl } = await createUrlInfo(info, {
      VIN,
      inorex,
      batchid,
      campaignid,
      MTN,
      targeturl: encodeURIComponent(actUrl),
      adtag,
    }, urlSchemaFromUrl);

    // 端内直接跳转页面
    if (isInWx && isToH5) {
      // 端内直跳时，就没有必要展示内容了
      this.isShowPage = false;
      redirectToUrl(jumpUrl);
      // 微信环境下，因为会跳转，所以不展示页面
      return;
    }

    this.urlSchema = jumpUrl;

    // 端外
    if (!isInWx) {
      redirectToWxApp(jumpUrl);
      this.isShowPage = true;
      return;
    }

    // 端内拉起小程序
    if (!isToH5) {
      // 直接关闭窗口
      if (url.getUrlParam('closeWindow')) {
        // @ts-ignore
        wx.closeWindow();
        setTimeout(() => {
          redirectToWxApp(jumpUrl);
        }, 500);
      } else {
        redirectToWxApp(jumpUrl);
        // 延迟展示，避免跳转之前闪现
        setTimeout(() => {
          this.isShowPage = true;
          console.debug('== showPage ==');
        }, 2000);
      }
    }

    // 如果既不存在actUrl，也不是跳转小程序，则什么都不做
  }
  private initReportData(confId: string, adtag: string, actUrl: string) {
    mtnBiReport({
      fconfid: confId,
      fadtag: adtag,
      ftargeturl: actUrl,
    });
  }
  /** url上直接带落地页 */
  get configFromUrl() {
    let returnConfig = {};
    const actUrl = decodeURIComponent(url.getUrlParam('url'));
    if (actUrl && /^https:\/\/prom.wechatpay.com.hk\/.*$/.test(actUrl)) { // 预防钓鱼网站跳转，比如https://prom.wechatpay.com.hk:443/discount-code-thirdapp/index.shtml?url=https://prom.wechatpay.com.hk.tst.xss&ADTAG=springactshareoutside&scheme=d2VpeGluOi8vZGwvYnVzaW5lc3MvP3Q9QU5lOHdRYWdidW4%3D&confId=2022spring
      // 要保证actUrl不为空
      returnConfig = { actUrl: handleActUrl({ actUrl }) };
    }
    return returnConfig;
  }
}
